const features = [
  {
    icon: 'ri-arrow-down-double-fill',
    color: 'text-secondary-500',
    bg: 'bg-secondary-500/15',
    title: '下拉式翻页',
    desc: '一屏一图连贯滚动，翻页流畅不卡顿，长故事也能一口气看完。',
  },
  {
    icon: 'ri-hd-fill',
    color: 'text-primary-500',
    bg: 'bg-primary-500/15',
    title: '高清不伤眼',
    desc: '全程高清画质，细节清晰锐利，长时间阅读也不易疲劳。',
  },
  {
    icon: 'ri-moon-fill',
    color: 'text-accent-400',
    bg: 'bg-accent-500/15',
    title: '夜间模式',
    desc: '一键切换柔和夜间模式，亮暗可调，追更到深夜也舒适。',
  },
  {
    icon: 'ri-bookmark-fill',
    color: 'text-secondary-400',
    bg: 'bg-secondary-500/15',
    title: '智能书签',
    desc: '自动记录阅读进度，换个设备接着看，章节绝不重复。',
  },
  {
    icon: 'ri-chrome-fill',
    color: 'text-primary-400',
    bg: 'bg-primary-500/15',
    title: '即开即读',
    desc: '无需下载安装，电脑、平板、手机浏览器打开就能看。',
  },
  {
    icon: 'ri-vip-diamond-fill',
    color: 'text-accent-400',
    bg: 'bg-accent-500/15',
    title: '全程免费',
    desc: '热门连载、经典完结统统免费开放，随时随地放心追。',
  },
];

export default function ExperienceSection() {
  return (
    <section id="feature" className="mx-auto max-w-6xl px-4 py-12 md:px-6 md:py-16 lg:px-8">
      <div className="grid grid-cols-1 items-center gap-8 lg:grid-cols-2">
        <div>
          <p className="mb-3 inline-flex items-center gap-2 rounded-full border border-accent-400/40 bg-accent-500/10 px-3 py-1 text-xs text-accent-400">
            <i className="ri-palette-line" />
            为阅读而生的体验
          </p>
          <h2 className="flex items-center gap-2 font-heading text-2xl text-foreground-950 md:text-3xl">
            网页版也能有
            <span className="text-primary-500">沉浸式阅读体验</span>
          </h2>
          <p className="mt-3 max-w-lg text-sm leading-7 text-foreground-700">
            不用下载、不用占内存，打开网页即可进入纯净阅读模式。下拉式翻页、高清画质、夜间护眼与智能书签，把每一分体验都打磨到位，让你只看漫画、不被打扰。
          </p>

          <div className="mt-6 grid grid-cols-1 gap-3 sm:grid-cols-2">
            {features.map((f) => (
              <div
                key={f.title}
                className="flex items-start gap-3 rounded-lg bg-background-100 p-4 ring-1 ring-background-200/70 transition hover:ring-accent-400/40"
              >
                <span className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-md ${f.bg}`}>
                  <i className={`${f.icon} text-lg ${f.color}`} />
                </span>
                <div>
                  <h3 className="text-sm font-bold text-foreground-950">{f.title}</h3>
                  <p className="mt-1 text-xs leading-5 text-foreground-600">{f.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="relative">
          <img
            src="https://readdy.ai/api/search-image?query=modern%20manga%20reading%20app%20mockup%20on%20phone%20screen%20showing%20colorful%20comic%20panel%2C%20dark%20background%20desk%20with%20warm%20accent%20lighting%2C%20floating%20interface%20elements%20like%20bookmark%20and%20brightness%20icons%2C%20cinematic%20product%20shot%2C%20coral%20and%20amber%20glow%2C%20high%20detail%2C%20clean%20composition&width=800&height=1000&seq=feature-reading-01&orientation=portrait"
            alt="YY免费漫画网页版下拉式高清阅读体验"
            className="w-full rounded-lg object-cover"
          />
          <div className="absolute -bottom-4 left-6 flex items-center gap-3 rounded-lg bg-background-100 px-4 py-3 ring-1 ring-background-300/70">
            <span className="flex h-9 w-9 items-center justify-center rounded-full bg-accent-500 text-background-50">
              <i className="ri-battery-2-fill" />
            </span>
            <div>
              <p className="text-xs font-bold text-foreground-950">省电阅读模式</p>
              <p className="text-[11px] text-foreground-600">长时间看也不烫手</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}